import { Component } from 'react';
import ReactQuill from 'react-quill';
import { connect } from 'react-redux';

import Button from 'components/atoms/Button';
import Form from 'components/atoms/Form';
import FormGroup from 'components/atoms/FormGroup';
import Icon from 'components/atoms/Icon';
import { bindActionCreators, Dispatch } from 'redux';
import { commentUpdate } from 'services/comments';
import { setErrorHandlerAction, SetErrorHandlerAction } from 'store/actions/errorsActions';
import { PortType, RootState } from 'types';
import { ActionsType } from 'types/system';
import { formatServerErrors } from 'utils/formatServerErrors';
import { translate } from 'utils/translate';

interface EditCommentModelProps {
    //unused props
    children?: string | JSX.Element | JSX.Element[];

    //unused props
    language: string;

    id?: string;
    data: any;
    port: PortType;
    actions: ActionsType | undefined;
    setErrorHandlerAction: SetErrorHandlerAction;
}

interface EditCommentModelState {
    errors: object;
    data: any | null;
}

class EditCommentModel extends Component<EditCommentModelProps, EditCommentModelState> {
    constructor(props: EditCommentModelProps) {
        super(props);
        this.state = {
            data: props.data,
            errors: {},
        };
    }

    setComment = (text: string) => {
        this.setState({
            data: { text },
        });
    };

    handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();
        this.setState({ errors: {} }, () => {
            commentUpdate(this.props.port.id, this.props.data.id, this.state.data)
                .then(() => {
                    this.props.actions?.onConfirm();
                    this.props.actions?.onCancel();
                })
                .catch((errors) => {
                    switch (errors.response?.status) {
                        case 422:
                            this.setState({ errors: formatServerErrors(errors) });
                            break;
                        default:
                            this.props.setErrorHandlerAction(errors);
                            break;
                    }

                    return;
                });
        });
    };

    handleFormCancel = () => {
        this.props.actions?.onCancel();
    };

    render() {
        return (
            <>
                <Form onSubmit={this.handleFormSubmit} className="bg-white shadow p-4 w-full rounded">
                    <div id={`Drag-${this.props.id}`} className="flex justify-between mb-4 no-select ">
                        <div className="text-lg leading-6 font-bold">{translate('Edit comment')} </div>
                        <div
                            onTouchEnd={this.handleFormCancel}
                            onClick={this.handleFormCancel}
                            className="cursor-pointer"
                        >
                            <Icon>
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                            </Icon>
                        </div>
                    </div>

                    <FormGroup className="short" horizontal={false}>
                        <ReactQuill
                            modules={{
                                toolbar: [
                                    [{ size: ['medium', false, 'large', 'huge'] }],
                                    ['bold', 'italic', 'underline'],
                                    [{ list: 'ordered' }, { list: 'bullet' }],
                                    [{ align: [] }],

                                    ['clean'],
                                ],
                            }}
                            formats={[
                                'header',
                                'size',
                                'bold',
                                'italic',
                                'underline',
                                'strike',
                                'blockquote',
                                'list',
                                'bullet',
                            ]}
                            value={this.state.data.text}
                            onChange={(value) => {
                                const temp = this.state.data;
                                temp.text = value;
                                this.setComment(value);
                            }}
                        />
                    </FormGroup>

                    <div className="flex justify-end">
                        <div className="mt-2 flex gap-3">
                            <Button
                                className="px-4 py-2 font-bold border border-gray-400"
                                onClick={this.handleFormCancel}
                            >
                                {translate('Cancel')}
                            </Button>
                            <Button type="submit" className="px-4 py-2 bg-primary-submit rounded-md text-white">
                                {translate('Save')}
                            </Button>
                        </div>
                    </div>
                </Form>
            </>
        );
    }
}

const EditCommentModelStateToProps = (state: RootState) => ({
    language: state.user.user.language,
    port: state.port.port,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const EditCommentModelDispatchToProps = (dispatch: Dispatch) => ({
    setErrorHandlerAction: bindActionCreators(setErrorHandlerAction, dispatch),
});

export default connect(EditCommentModelStateToProps, EditCommentModelDispatchToProps)(EditCommentModel);
